import { Content, ContentProps, Flex, usePlatformProps } from '@acsbe/ui';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import CardDots from '../../../assets/card-dots.svg';

type BillingDetailsProps = {
  country: string;
  zipCode?: string | null;
  cardDigits: string;
  expiryMonth: number;
  expiryYear: number;
  isInvalid?: boolean;
  size?: ContentProps['size'];
};

export const BillingDetails: FunctionComponent<BillingDetailsProps> = ({
  country,
  zipCode,
  cardDigits,
  expiryMonth,
  expiryYear,
  isInvalid,
  size,
}) => {
  const p = usePlatformProps();
  const { t } = useTranslation();
  const props = {
    size,
    variant: 'element',
    scale: isInvalid ? 'disabled' : 'base',
  } as const;

  return (
    <Flex row gap={3} wrap="wrap" {...p.uptoPhablet({ gap: 1 })}>
      <Content inline {...props}>
        {country}
        {zipCode ? `, ${zipCode}` : null}
      </Content>

      <Content role="presentation" inline aria-hidden="true" {...props}>
        |
      </Content>

      <Flex gap={1} row align="center">
        <Content
          inline
          lineHeight={0}
          variant="element"
          scale={isInvalid ? 'disabled' : 'base'}
        >
          <CardDots aria-label={t('BILLING_PAGE.LAST_DIGITS')} />
        </Content>

        <Content inline {...props}>
          {cardDigits}
        </Content>
      </Flex>

      <Content role="presentation" inline aria-hidden="true" {...props}>
        |
      </Content>

      <Content inline {...props}>
        {t('BILLING_PAGE.EXPIRES')} {expiryMonth}/
        {expiryYear.toString().slice(-2)}
      </Content>
    </Flex>
  );
};
